import { TiWarningOutline } from 'react-icons/ti';
import { warningColor } from '@assets/jss/material-dashboard-pro-react';

export const stringResources = {
    CONTRACT_LIST: {
        MAX_DATE_MESSAGE: '`From` date should not after `to` date',
        MIN_DATE_MESSAGE: '`To` date should not before `from` date',
        COPY_CONTRACT: 'Copy data from the existing contract',
        DELETE_RATE_CONFIRM_MESSAGE: <span>Are you sure you would like to delete this rate?</span>,
        DELETE_SHARE_CONFIRM_MESSAGE: <span>Are you sure you would like to delete this share?</span>,
        DELETE_WORKBY_CONFIRM_MESSAGE: <span>Are you sure you would like to delete this workby?</span>,
        DELETE_CATCH_PRICE_LIST_CONFIRM_MESSAGE: <span>Are you sure you would like to delete this catch price list?</span>,
        DELETE_COST_CONFIRM_MESSAGE: <span>Are you sure you would like to delete this cost?</span>,
        DELETE_ALL_LINES: 'Are you sure you would like to delete all lines from this contract?'
    },
    FISHING_TRIP: {
        START_DATE_MAX_DATE_MESSAGE: 'Start date should not after end date',
        END_DATE_MIN_DATE_MESSAGE: 'End date should not be before start date',
        LANDING_DATE_MIN_DATE_MESSAGE: 'Landing date should not be before start date',
        COPY_FISHING_TRIP: 'Copy data from the existing fishing trip',
        PERIOD_OUT_OF_TRIP_DATE_WARNING: 'The period dates fall outside of the trip range',
        PERIOD_NOT_MATCH_TRIP_RANGE: 'Does not match trip range',
        PERIOD_CONFLICT_WITH_OTHERS: 'Conflicts with other periods',
        TRIP_LENGTH_INVALID: 'Trip length is unknown',
        DUPLICATED_CREW_WARNING: 'Potentially duplicated record',
        OUT_OF_SHARE_RANGE_WARNING: 'Outside share range',
        CATCH_UPDATE_FROM_CONTRACT: 'Are you sure you would like to update all fish prices from contract? This will override any existing fish rates.',
        CREW_UPDATE_FROM_CONTRACT:
            'Are you sure you would like to update all rates and shares from contract? This will override any existing rates and shares.',
        UPDATE_FROM_CONTRACT_FINISH: 'Updating from contract finished',
        POPULATE_CE_POINTS:
        'This will populate the continuous engagement points for the crew members based on the days worked and contract points. Proceed?',
        POPULATE_CE_EXTRAS:
            'This will populate the continuous engagement for the crew members based on their CE points and contract rates. Proceed?',
        POPULATE_SUCCESS: 'Populated successfully!',
        DELETE_FROM_ACTIONS_CONFIRM_MESSAGE: 'Are you sure you would like to delete this export file and report?',
        SEND_TO_ALL_CREW_CONFIRM_MESSAGE: 'Are you sure you would like to send all crew email with worker summary report?',
        COMPLETE_CONFIRM_MESSAGE:
            'Are you sure you would like to complete this fishing trip? The fishing trip will be locked and no changes can be made once completed.',
        UNCOMPLETE_CONFIRM_MESSAGE:
            'Are you sure you would like to uncomplete this fishing trip? The fishing trip will be unlocked and changes can be made once uncompleted.',
        BUTTON_DISABLED_AFTER_EOT_POSTED_MESSAGE: 'EOT was posted to ledger!',
        BUTTON_DISABLED_AFTER_EXTRAS_POSTED_MESSAGE: 'Extras were posted to ledger!',
        NO_DATA_TO_UPDATE: 'No data to update',
        UPDATE_FROM_CONTRACT: 'Updating from contract in progress.',
        EOT_POSTING: 'Posting End of Trip to ledger...',
        EOT_REPORTS_GENERATING: 'Reports are being generated in the background...',
        EOT_POSTED: 'End of trip posted successfully!',
        CREW_DELETE_ALL: 'Are you sure you would like to delete all crew from this trip?',
        CREW_DELETE_PERIOD: 'Are you sure you would like to delete all crew from this period?',
        CATCH_DELETE_ALL: 'Are you sure you would like to delete all catch from this trip?',
        CATCH_DELETE_PERIOD: 'Are you sure you would like to delete all catch from this period?',
        COST_DELETE_ALL: 'Are you sure you would like to delete all costs from this trip?',
        COST_DELETE_PERIOD: 'Are you sure you would like to delete all costs from this period?',
        CE_POINTS_DELETE_ALL: 'Are you sure you would like to delete all ce points from this trip?',
        EXTRA_DELETE_ALL: 'Are you sure you would like to delete all extras from this trip?',
    },
    REDUX_SLICE: {
        POST_SUCCESS: 'Posted successfully!',
        DELETE_SUCCESS: 'Deleted successfully!',
        CREATE_SUCCESS: 'Created successfully!',
        UPDATE_SUCCESS: 'Updated successfully!',
        DISTRIBUTE_SUCCESS: 'Distributed successfully!',
        DUPLICATE_SUCCESS: 'Duplicated successfully!',
        NO_DEFAULT_RATE: 'There is no default rate for the selected product in the contract',
        DELETE_LOADING: 'Deleting...',
    },
    WORK_BY_HOURS: {
        DELETE_LINE_CONFIRM_MESSAGE: 'Are you sure you would like to delete this line?',
    },
    IMPORT: {
        DATA_INVALID: 'There is some invalid data or the template is empty, please correct and re-upload file',
        PERIOD_CATEGORY_MISMATCH_WARNING: 'This period has different category name on fishing trip',
        CATCH_PRICE_LIST_IMPORTING: 'Catch price list import in progress',
        COSTS_IMPORTING: 'Costs import in progress.',
        RATES_IMPORTING: 'Rates import in progress.',
        SHARES_IMPORTING: 'Shares import in progress.',
        WORKBY_IMPORTING: 'Workby import in progress.',
        DATA_IMPORTING: 'Data import in progress.',
        EMPTY_IMPORT_ERROR: 'Please upload template with data',
        UPLOAD_FAILED_ERROR: 'You can only upload the file from template',
        TRIP_CREW_IMPORTING: 'Trip crew import in progress.',
        TRIP_COSTS_IMPORTING: 'Trip costs import in progress.',
        TRIP_CATCH_IMPORTING: 'Trip catch import in progress.',
        TRIP_EXTRAS_IMPORTING: 'Trip extras import in progress.',
        TRIP_CATCH_PERIOD_OVERRIDE_MESSAGE: 'System Override.',
        TRIP_CATCH_DATE_OUTSIDE_TRIP_DATE_MESSAGE: 'The catch date is outside trip start and end date.',
        D365_DATA_INVALID: 'There is some invalid data, please correct or re-fetch',
        WORKBYLINE_IMPORTING: 'Importing workby hour csv file...',
    },
    AUTH_SLICE: {
        LOG_OUT_SUCCESS: 'Signed out!',
    },
    EXPORT: {
        CONTRACT_LIST: 'Exporting contract xlsx file...',
        FISHING_TRIP_LIST: 'Exporting fishing trip xlsx file...',
        ROSTER: 'Exporting roster xlsx file...',
        WORKBY: 'Exporting workby hour csv file...',
    },
    NO_DEFAULT_WARNING: {
        SHARE: 'There is no default share for the selected worker or position in the contract',
        RATE: 'There is no default rate for the selected worker or position in the contract',
    },
    YUP: {
        REQUIRED: '*required',
        MIN_1_CHARS: 'Minimum 1 character',
        MIN_2_CHARS: 'Minimum 2 characters',
        MAX_10_CHARS: 'Maximum 10 characters',
        MAX_50_CHARS: 'Maximum 50 characters',
        MAX_255_CHARS: 'Maximum 255 characters',
        NUMBER_REQUIRED: '*must be a number',
        NUMBER_GREATER_OR_EQUAL_ZERO: '*must be greater or equal to zero',
        NUMBER_GREATER_THAN_ZERO: '*must be greater than zero',
        NUMBER_LESS_THAN_999999999: '*must be less than 999999999',
        NUMBER_MORE_THAN_NEGATIVE_999999999: '*must be more than -999999999',
        INVALID_EMAIL: 'Invalid email address',
    },
    EMAIL: {
        EMAIL_SENDING: 'Sending the email...',
        SEND_SUCCESS: 'Email sent successfully!',
        SEND_FAILED: 'Email sending failed!',
        LABOUR_ADVANCE_EMAIL_SUBJECT: 'Labour Advance Report',
        CREW_SETTLEMENT_EMAIL_SUBJECT: 'Crew Settlement Report',
        VESSEL_MANAGER_EMAIL_SUBJECT: 'Vessel Manager Report',
        WASHUP_EMAIL_SUBJECT: 'Washup Report',
        WORKER_SUMMARY_SUBJECT: 'Individual Report',
        EXTRAS_EMAIL_SUBJECT: 'Extras Report',
    },
    REPORT: {
        FILE_EXTENSION: '.pdf',
        WEEKLY_PAY_TITLE: 'Weekly Pay',
        EOT_TITLE: 'Crew Settlement report',
        WASHUP_TITLE: 'Washup report',
        EXTRAS_TITLE: 'Extras report',
    },
};

export const ITEM_NOT_FOUND = (code: string | null) => `Item '${code}' was not found in the database.`;

export const LABOUR_ADVANCE_REPORT_FILE_NAME = (prefix: string) => `${prefix} Labour Advance Report${stringResources.REPORT.FILE_EXTENSION}`;

export const WASHUP_REPORT_FILE_NAME = (prefix: string) => `${prefix} Washup Report${stringResources.REPORT.FILE_EXTENSION}`;
export const EXTRAS_REPORT_FILE_NAME = (prefix: string) => `${prefix} Extras Report${stringResources.REPORT.FILE_EXTENSION}`;

export const WORKER_SUMMARY_REPORT_FILE_NAME = (prefix: string) => `${prefix} Summary Report${stringResources.REPORT.FILE_EXTENSION}`;

export const FULL_NAME = (worker?: { firstName: string, middleName: string, lastName: string }) =>
    worker
        ? worker.middleName.length > 0
            ? `${worker.firstName.trim()} ${worker.middleName.trim()} ${worker.lastName.trim()}`
            : `${worker.firstName.trim()} ${worker.lastName.trim()}`
        : '';

export const FISHING_TRIP_DELETE_CONFIRM_MESSAGE = (fishingTripNumber: string) => <span>Are you sure you would like to delete fishing trip <strong>{fishingTripNumber}</strong> and the associated periods, catch, crew and costs?</span>;

export const FISHING_TRIP_PERIOD_DELETE_CONFIRM_MESSAGE = (category: string) => <span>Are you sure you would like to delete <strong>{category}</strong> and all the associated catch, crew and costs?</span>;

export const FISHING_TRIP_RELATES_DELETE_CONFIRM_MESSAGE = (name: string, category: string) => <span>Are you sure you would like to delete <strong>{name}</strong> from <strong>{category}</strong>?</span>;

export const CONTRACT_DELETE_CONFIRM_MESSAGE = (contractNumber: string) => <span>Are you sure you would like to delete contract <strong>{contractNumber}</strong>?</span>;

export const MASTERDATA_DELETE_CONFIRM_MESSAGE = (name: string) => <span>Are you sure you would like to delete <strong>{name}</strong>?</span>;

export const CE_POINT_DELETE_CONFIRM_MESSAGE = (name: string) => <span>Are you sure you would like to delete <strong>{name}</strong>'s points?</span>;

export const TOOLTIP = (
    <span style={{ height: 22 }}>
        <TiWarningOutline size={18} fill={warningColor[0]} />
    </span>
);

export const EOT_REPORTS_GENERATING = (fishingTripNumber: string) => `${fishingTripNumber} Reports are being generated`;
export const EOT_WEBJOB_POSTING = (fishingTripNumber: string) => `${fishingTripNumber} End of trip is being posted`;